// extracted by mini-css-extract-plugin
module.exports = {"accent":"#77d3d4","border":"#e5ebed","error":"#eb534b"};